

	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	@Component({
		name: 'report',
		components:{
		}
	})
	export default class contractinfoaa extends Vue {
		gzffForm = {month:'',type:0,userid:''}
		loading = false
		checkers = []
		pickerOptions = {
		disabledDate:(time:Date) => {
			return (this.maxAndMinMonth.min&&(time.getTime() < this.maxAndMinMonth.min.getTime()))|| (this.maxAndMinMonth.max&&(time.getTime() > this.maxAndMinMonth.max.getTime()));
		},
	}
		maxAndMinMonth:{min?:Date,max?:Date}={min:undefined,max:undefined}
		rules= {
			reportType: [
				{ required: true, message: '请选择类别', trigger: 'change' }
			],
			type: [
				{ required: true, message: '请选择用工性质', trigger: 'change' }
			],
			month: [
				{ required: true, message: '请选择月份', trigger: 'change' }
			],
			userid: [
				{ required: true, message: '请选择用户', trigger: 'change' }
			]
		}
		created() {
			this.findMaxAndMinMonth()
		}
		mounted() {


			// this.dataLists = salarydata
		}
		reverse() {
			this.$refs['form'].validate((valid:boolean) => {
				if (valid) {
					if (this.gzffForm.type === 0) {
						this.$router.push({
							path: "/salary/reversein",
							query: { month: this.gzffForm.month },
						});
					} else if (this.gzffForm.type === 1) {
						this.$router.push({
							path: "/salary/reversehz",
							query: { month:  this.gzffForm.month },
						});
					} else if (this.gzffForm.type === 2) {
						this.$router.push({
							path: "/salary/reverseschool",
							query: { month:  this.gzffForm.month },
						});
					}
				}
			});
		}
		changeTypeGzff(value?:number) {
			this.gzffForm.month = ''
			if (value||value === 0) {
				this.findMaxAndMinMonth()

			}
		}
		findMaxAndMinMonth() {
			this.$request({
				url: '/bjba/salaryStatus/findMaxAndMinMonthByType',
				params:{type:this.gzffForm.type},
				method: 'get'
			}).then(res => {
				// console.log(res.data.data)
				if (res.data.data && res.data.data.max && res.data.data.min) {
					this.maxAndMinMonth.max = this.$moment(res.data.data.max , "YYYY-MM").toDate()
					this.maxAndMinMonth.min = this.$moment(res.data.data.min , "YYYY-MM").toDate()
				}
			})
		}
	}
